/*       */

import React from 'react';

import TopicStatus from 'app/containers/Designer/Pipeline/Components/TopicStatus';

const panels = settingValues => {
    return [
        {
            type: 'custom',
            properties: {
                cid: 'topicStatusPanel',
                name: 'data',
                pipelineId: settingValues.details.id,
                handleConnectorStatus: settingValues.handleConnectorStatus,
                details: settingValues.details,
                pipelineMonitor: settingValues.pipelineMonitor,
                pipelineStatus: settingValues.pipelineStatus,
                getCurrentConnectorStatus: settingValues.getCurrentConnectorStatus,
                noBackground: true,
                Component: props => <TopicStatus {...props} />,
            },
        },
    ].filter(Boolean);
};

export default {
    defaults: {},
    panels: settingValues => panels(settingValues),
};
